import useController from '@common/hooks/useController'

// Native shim — read state from in-process ControllerStore.
// Web variant relies on `StorageControllerStateProvider` not mounted on RN.
export default function useStorageControllerState(): any {
  const { state } = useController('StorageController' as any)
  return state as any
}
